<app-organizer-shared-form-wrapper
  class="organizer-activity-creation-page-uploads"
  [activeStep]="2"
  [sectionTitle]="
    'organizer.activity_creation.birthday.upload.title' | translate
  "
  [sectionDescription]="
    'organizer.activity_creation.birthday.upload.text' | translate
  "
  [error$]="error$"
  [formGroup]="formGroup"
  (formSubmit)="submit()"
>
  <app-form-input-group
    [label]="'a11y.organizer.activity_creation.uploads.label' | translate"
    [isHiddenLabel]="true"
    [errorKey]="'activity_creation.uploads'"
    [errors]="getErrors()"
    class="block mb-1"
  >
    <app-upload-list
      #content
      formControlName="uploadChanges"
      [uploadCollection]="uploadCollection"
      [acceptedMimeTypes]="[mimeType.PDF]"
    >
    </app-upload-list>
  </app-form-input-group>
</app-organizer-shared-form-wrapper>
